import React from "react";
import PropTypes from "prop-types";

import { CREATOR_DASHBOARD_PHOTOS_PENDING } from "data/links";
import { useCurrentUser } from "contexts/CurrentUserContext";
import colors from "core/colors";

import {
    Container,
    Title,
    Message,
    Buttons,
    Button,
    IconContainer
} from "./styles";
import LimitIcon from "core/IllustrativeIcons/Limit";

const MaxTimeError = ({ daysRemaining = 30 }) => {
    const user = useCurrentUser();
    const username = (user && user.username) || "";
    return (
        <Container>
            <Title>You've reached the 30-day photo submission limit.</Title>
            <Message>You can submit again in {daysRemaining} days.</Message>
            <Buttons>
                <Button
                    href={CREATOR_DASHBOARD_PHOTOS_PENDING.replace(
                        ":username",
                        username
                    )}
                >
                    See Submission Status
                </Button>
            </Buttons>
            <IconContainer>
                <LimitIcon fillColor={colors.accent.lightMode.pansy} />
            </IconContainer>
        </Container>
    );
};

MaxTimeError.propTypes = {
    timeRemaining: PropTypes.number
};

export default MaxTimeError;
